/**
 * 酒店注册页面 
 * @Author: centerm.gaohan 
 * @Date: 2020-10-12 11:39:58 
 * @Last Modified by: centerm.gaohan
 * @Last Modified time: 2020-11-26 10:56:02
 */
import React, { useEffect, useState } from 'react';
import { Toast, Button, WingBlank, Flex } from 'antd-mobile';
import invariant from 'invariant';
import { useHistory } from 'react-router-dom'
import { ComponentFormItem, FormItmeType } from '../../../../components/form';
import { api } from '../../../../common/app';
import moment from 'moment';
import FormLayout from './compoents/form-layout'
import "./index.css";
import { prefixPath } from './compoents/util';
import FormFooter from './compoents/form-footer';
import { useUserinfo } from './compoents/form-hooks';
import { useUserStatus } from '../../../../common/hooks/user-status';

export default (props: any) => {
  let params = props.match.params;
  const isEdit = window.location.href.indexOf('mine') > -1;
  const pathPrefix = prefixPath(props.match.url);

  const history = useHistory();

  const { modelstatus, meetindex } = useUserStatus(params.id);

  // 通用formitem属性 
  const [baseFormItemProps, setBaseFormItemProps] = useState({} as any);

  // 是否需要酒店
  const [needHotelPickerData] = useState([{ value: '1', label: '是' }, { value: '0', label: '否' }]);
  const [needHotelSelected, setNeedHotelSelected] = useState('');

  // 入住的酒店
  const [hotelList, setHotelList] = useState([] as any[]);
  const [hotelPickerData, setHotelPickerData] = useState([] as { value: string; label: string }[]);
  const [hotelSelected, setHotelSelected] = useState('');

  // 入住时间
  const [checkTime, setCheckTime] = useState('' as any);
  const [outTime, setOutTime] = useState('' as any);

  // 房型相关
  const [hotelRoomList, setHotelRoomList] = useState([] as any[]);
  const [hotelRoomPickerData, setHotelRoomPickerData] = useState([{ label: '请先选择酒店', value: '-1' }] as { value: string; label: string }[]);
  const [hotelRoomSelected, setHotelRoomSelected] = useState('');

  // 用户备注
  const [userRemark, setUserRemark] = useState('');


  const [minDate, setMinDate] = useState(undefined as any);
  const [maxDate, setMaxDate] = useState(undefined as any);
  // 请求最迟和最早的入住时间
  useEffect(() => {
    console.log('meetindex', meetindex);
    if (meetindex.start_time && meetindex.end_time) {
      setMinDate(new Date(moment(meetindex.start_time * 1000).subtract(3, 'days').format('YYYY-MM-DD')));
      setMaxDate(new Date(moment(meetindex.end_time * 1000).add(3, 'days').format('YYYY-MM-DD')));
    }
  }, [meetindex]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }, []);

  useEffect(() => {
    // 是修改
    if (params.formid && hotelPickerData.length > 0 && hotelPickerData.length > 0) {
      (api as any).myHotelInfo({ meetid: params.id, id: params.formid })
        .then((result: any) => {
          if (result.code === 200) {
            console.log('myHotelInfo', result.result);
            const data = result.result.hotel_data;
            setNeedHotelSelected(`${data.is_need}`);
            setHotelSelected(`${data.hotel_id}`);
            setCheckTime(new Date(data.choice_time * 1000));
            setOutTime(new Date(data.out_time * 1000))
            setHotelRoomSelected(`${data.room_id}`);
            setUserRemark(data.remark);
          }
        })
        .catch((err: any) => {
          Toast.fail(err.message || '接口请求失败');
        });
    }
  }, [params.formid, hotelPickerData, hotelPickerData]);

  useEffect(() => {
    (api as any).getHotelList({ meetid: params.id }).then((result: any) => {
      if (result.code === 200) {
        setHotelList(result.result);
      }
    }).catch((err: any) => {
      Toast.fail(err.message || '接口请求失败');
    });
  }, []);

  // 请求到房间列表设置pickerdata
  useEffect(() => {
    if (hotelList.length !== 0) {
      const pickerData = hotelList.map((item) => {
        return {
          value: `${item.hotel_id}`,
          label: `${item.title}`,
        }
      });
      setHotelPickerData(pickerData);
    }
  }, [hotelList]);

  // 选择完了酒店和时间请求该酒店的房型 
  useEffect(() => {
    // 修改了酒店和时间重新选择房型

    if (!!hotelSelected && !!checkTime) {
      (api as any).getHotelRoomList({
        meetid: params.id,
        hotel_id: hotelSelected,
        choice_time: Math.ceil(checkTime.getTime() / 1000)
      })
        .then((result: any) => {
          if (result.code === 200) {
            setHotelRoomList(result.result);
          }
        })
        .catch((err: any) => {
          Toast.fail(err.message || '接口请求失败');
        });
    }
  }, [hotelSelected, checkTime]);

  // 请求到房间列表设置pickerdata
  useEffect(() => {
    if (hotelRoomList.length !== 0) {
      const pickerData = hotelRoomList.map((item) => {
        return {
          value: `${item.room_id}`,
          label: `${item.room_type}`,
        }
      });
      setHotelRoomPickerData(pickerData);
    }
  }, [hotelRoomList]);

  useEffect(() => {
    // 修改是否需要酒店之后调整其他formitem是否可用
    let baseProps: any = {};
    if (needHotelSelected === '0') {
      baseProps.disabled = true;
    } else {
      baseProps.disabled = false;
    }

    if (modelstatus.hotel?.status === false) {
      baseProps.disabled = true;
    }

    setBaseFormItemProps(baseProps);
  }, [needHotelSelected, modelstatus]);

  const onNeedHotelPickerOk = (params: string[]) => {
    setNeedHotelSelected(params[0]);
  }

  const onHotelPickerOk = (params: string[]) => {
    setHotelSelected(params[0]);
  }

  const onCheckTimeOk = (date: any) => {
    setCheckTime(date);
  }

  const onHotelRoomOk = (params: string[]) => {
    setHotelRoomSelected(params[0]);
  }

  /**
   * 跳过设置酒店
   *
   */
  const onSkip = () => {
    // 酒店信息注册结束，下一步是接送机或者结束
    const meetid = params.id;
    (api as any).showButton({ meetid })
      .then((result: any) => {
        console.log('result', result);
        if (result.code !== 200) {
          return;
        }
        // 会议开启了接送机
        if (!!result.result.is_plain && modelstatus.plain.status === true) {
          history.replace(`/${pathPrefix}/plain/${meetid}`);
          return;
        }
        history.replace(`/${pathPrefix}/index/${meetid}`);
      }).catch((err: any) => {
        console.log('err', err);
      });
  }

  /**
   * 用户点击填好之后触发验证然后调接口
   * 
   */
  const onSubmit = async () => {
    try {
      const isMine = window.location.href.indexOf('/mine/') > -1;
      const isEdit = !!params.formid;

      if (needHotelSelected === '1') {
        invariant(hotelSelected, '请选择酒店');
        invariant(hotelRoomSelected, '请选择房型');
      }

      const payload = {
        ...(isEdit ? { id: params.formid } : {}),
        meetid: params.id,
        is_need: needHotelSelected,
        room_id: Number(hotelRoomSelected),
        choice_time: !!checkTime && Math.ceil(checkTime.getTime() / 1000),
        out_time: !!outTime && Math.ceil(outTime.getTime() / 1000),
        remark: userRemark,
      };
      const result = await (api as any).choiceHotel(payload);
      invariant(result.code === 200, result.message || ' ');
      Toast.success("酒店信息更新成功~", 1);

      setTimeout(() => {
        // 修改返回
        if (!!isMine) {
          history.goBack();
          return;
        }
        // 酒店信息注册结束，下一步是接送机或者结束
        const meetid = params.id;
        (api as any).showButton({ meetid })
          .then((result: any) => {
            console.log('result', result);
            if (result.code !== 200) {
              return;
            }
            // 会议开启了接送机
            if (!!result.result.is_plain && modelstatus.plain.status === true) {
              history.replace(`/${pathPrefix}/plain/${meetid}`);
              return;
            }
            history.replace(`/${pathPrefix}/index/${meetid}`);
          }).catch((err: any) => {
            console.log('err', err);
          });
      }, 1000);

    } catch (error) {
      Toast.fail(error.message, 1);
    }
  }

  return (
    <FormLayout title='填写酒店信息'>
      <ComponentFormItem
        formTitle='是否需要酒店'
        cols={1}
        formType={FormItmeType.Picker}
        data={needHotelPickerData}
        value={[needHotelSelected]}
        onOk={onNeedHotelPickerOk}
        disabled={modelstatus.hotel?.status === false}
      />
      <ComponentFormItem
        formTitle='需要入住的酒店'
        cols={1}
        formType={FormItmeType.Picker}
        data={hotelPickerData}
        value={[hotelSelected]}
        onOk={onHotelPickerOk}
        {...baseFormItemProps}
      />
      <ComponentFormItem
        formTitle='入住时间'
        mode='date'
        formType={FormItmeType.DatePicker}
        value={checkTime}
        onOk={onCheckTimeOk}
        {...minDate !== undefined ? { minDate: minDate } : {}}
        {...maxDate !== undefined ? { maxDate: maxDate } : {}}
        {...baseFormItemProps}
      />
      <ComponentFormItem
        formTitle='房型'
        cols={1}
        formType={FormItmeType.Picker}
        data={hotelRoomPickerData}
        value={[hotelRoomSelected]}
        onOk={onHotelRoomOk}
        {...baseFormItemProps}
      />
       <ComponentFormItem
        formTitle='退房时间'
        mode='date'
        formType={FormItmeType.DatePicker}
        value={outTime}
        onOk={setOutTime}
        {...minDate !== undefined ? { minDate: minDate } : {}}
        {...maxDate !== undefined ? { maxDate: maxDate } : {}}
        {...baseFormItemProps}
      />
      <ComponentFormItem
        formTitle='酒店备注信息'
        formType={FormItmeType.Input}
        value={hotelSelected ? hotelList.find(h => h.hotel_id === Number(hotelSelected))?.notice || '无' : '请先选择酒店'}
        disabled={true}
        maxLength={50}
        onChange={() => { }}
      />
      <ComponentFormItem
        formTitle='用户备注'
        formType={FormItmeType.Input}
        maxLength={50}

        placeholder='用户备注'
        value={userRemark}
        onChange={(e: any) => setUserRemark(e.target.value)}
        {...baseFormItemProps}
      />

      <FormFooter
        meetid={params.id}
        type='hotel'
        isEdit={isEdit}
        onSkip={onSkip}
        onSubmit={onSubmit}
      />
    </FormLayout>
  );
}